import { createContext, Dispatch, SetStateAction } from 'react';

export interface MobileViewCtx {
  showMobileView: boolean;
  setShowMobileView: Dispatch<SetStateAction<MobileViewCtx['showMobileView']>>;
}

const MobileViewContext = createContext({
  showMobileView: false,
  setShowMobileView: () => true,
} as MobileViewCtx);

export default MobileViewContext;
